<template>
  <div>
    <div class="news">
      <!-- <div @click="btn('/media?source=index')" class="more">read more</div> -->
      <div class="newsList">
        <div class="topnews">

          <div class="topNews" v-for="(item,index) in topNews.slice(0,1)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
            <img :src="item.logo">
            <div>
              <div>
                <div class="label">
                  {{item.firstLabel}}
                </div>
                <div class="label" v-for="label in item.othersLabel.split(',').slice(0,3)">
                  {{label}}
                  <!-- .split(",") -->
                </div>
              </div>

              <div class="title">
                {{ item.newsTitle }}
              </div>
            </div>
            <div class="newsDesc overflowMulityText3">
              {{ item.newsDesc }}
            </div>

          </div>
          <div @click="btn('/media?source=index')" class="more">read more</div>
        </div>
        <div class="notopnews">

          <div class="one" v-for="(item,index) in newsList.slice(0,3)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
            <img :src="item.logo">
            <div>
              <div>
                <div class="label">
                  {{item.firstLabel}}
                </div>
                <div class="label" v-for="label in item.othersLabel.split(',').slice(0,3)">
                  {{label}}

                </div>
              </div>

              <div class="title">
                {{ item.newsTitle }}
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- <div class="swiperNews">
      <swiper :options="swiperOption" :not-next-tick="notNextTick" ref="mySwiper" class="sw">

        <div class="swiper-button-prev" slot="button-prev"><i class="el-icon-arrow-left"></i></div>
        <swiper-slide v-for="(item,index) in newsList" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
          <div class="swiperNews-box">
              <img :src="item.logo">
          </div>
        </swiper-slide>
      </swiper>

    </div> -->


    <el-dialog title="" :visible="DialogShow" width="45%" @close="DialogShow=false">
      <span>
        <div class="from">
          <div class="formtitle">Please fill in your information</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="First Name" prop="firstname">
              <el-input v-model="ruleForm.firstname" />
            </el-form-item>
            <el-form-item label="Last Name" prop="lastname">
              <el-input v-model="ruleForm.lastname" />
            </el-form-item>
            <el-form-item label="Email" prop="mail">
              <el-input v-model="ruleForm.mail" />
            </el-form-item>
            <el-form-item label="Company" prop="company">
              <el-input v-model="ruleForm.company" />
            </el-form-item>
            <el-form-item prop="check" style="width:100%">

              <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;">Yes, I would like to receive digital communications from Holden brands. I may opt-out of communications at any time using the unsubscribe link at the bottom of any email communication.</span>
            </el-form-item>
          </el-form>

        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogShow = false">cancel</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">submit</el-button>

      </span>
    </el-dialog>
  </div>

</template>

<script>
// import { Swiper, SwiperSlide } from 'swiper/vue';
// import 'swiper/swiper-bundle.css';
const defaultForm = {
  action: "News",
  actionCase: "Readnews",
  targetName: "",
  mail: "",
  firstname: "",
  lastname: "",
  company: "",
  check: true
};
import { getNewsList } from "@/api/api";

export default {
  // components: {
  //   Swiper,
  //   SwiperSlide
  // },
  data() {
    return {
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      newsList: [],
      topNews: [],
      DialogShow: false,
  slides: ['Slide 1', 'Slide 2', 'Slide 3', 'Slide 4', 'Slide 5'],
      rules: {
        firstname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        lastname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        company: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        mail: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly.", trigger: ["blur"] }
        ]
        // check: [{ required: true, message: "Please complete this required field", trigger: "blur" }, { validator: check }]
      },
      notNextTick: true,
      swiperOption: {
        // swiper options 所有的配置同swiper官方api配置
        autoplay: false, // 自动播放的时间间隔
        slidesPerView: 3, //一次显示的数量
        direction: "vertical", // 垂直轮播
        grabCursor: true,
        setWrapperSize: true,
        loop: false, //  循环播放
        autoHeight: true,
        // pagination: ".swiper-pagination",
        paginationClickable: true,
        initialSlide: 0,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        // scrollbar: ".swiper-scrollbar",
        mousewheelControl: true,
        observeParents: true,
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: true,
        // swiper callbacks
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        onTransitionStart(swiper) {
          console.log(swiper);
        }
        // more Swiper configs and callbacks...
        // ...
      }
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      getNewsList({
        pageSize: 0,
        pageIndex: 1,
        status: 1, //启用
        origin: 1 //前台
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "Failed to query news information");
          return;
        } else {
          this.newsList = res.datalist.filter(k => k.topFlag != 1);
          this.topNews = res.datalist.filter(k => k.topFlag == 1);
        }
      });
    },
    toDetail(id, subscribe, newsTitle) {
      if (subscribe == 1 && !this.$cookies.isKey("HoldenCookies")) {
        this.submitId = id;
        this.DialogShow = true;
        this.submitTitle = newsTitle;
      }
      // 如果需要权限并且没有cookie
      else {
        this.$router.push({ name: "newsDetail", query: { id: id, source: "index" } });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  // background-color: #fff;
  padding: 0 120px;
  font-size: 18px;
  position: relative;
  .more {
    // width: 160px;
    padding: 0 20px;
    font-size: 16px;
    color: #409eff;
    background-color: #ecf5ff;
    border: 1px solid #409eff;
    border-radius: 8px;
    text-align: center;
    position: absolute;
    left: 120px;
    bottom: 30px;
  }
  .more:hover {
    cursor: pointer;
    color: #2cb1e9;
  }
  .newsList {
    // text-align: center;
    display: flex;
    justify-content: space-between;
    // flex-wrap: wrap;
    .topnews {
      width: 50%;
      height: 100%;
      background-color: #fff;

      .topNews {
        border: 1px solid #d5dbe5;
        border-radius: 8px;
        box-shadow: 4px 4px 4px 0 #d5dbe5;
        padding: 14px;
        cursor: pointer;

        img {
          width: 100%;
        }
        .title {
          // margin-top: 10px;
          font-weight: 700;
        }
        .label {
          margin: 15px 10px 0 0;
          font-size: 12px;
          display: inline-block;
          padding: 0.7px 7.5px 2px;
          background: #e8f2ff;
          border-radius: 4px;
          color: #2186c8;
        }
        .newsDesc {
          margin-top: 20px;
        }
      }
    }
    .notopnews {
      width: 47%;
    }
    .one {
      background-color: #fff;
      display: flex;
      cursor: pointer;
      padding: 14px;
      width: 100%;
      margin: 0px auto 20px;
      border: 1px solid #d5dbe5;
      border-radius: 8px;
      box-shadow: 4px 4px 4px 0 #d5dbe5;
      img {
        width: 300px;
        height: 170px;
      }
      .title {
        margin-left: 10px;
      }
      .label {
        margin-left: 10px;
        font-size: 12px;
        display: inline-block;
        padding: 0.7px 7.5px 2px;
        background: #e8f2ff;
        border-radius: 4px;
        color: #2186c8;
      }
    }
    .two {
      width: 40%;
    }
  }
  .swiperNews{
  .swiperNews-box{
    img{
      width: 100px;
    }
  }
  }
}
.swiper-container {
  width: 100%;
  height: 400px;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  background: #fff;
  border: 1px solid #ddd;
  height: 100%;
}
</style>